<template slot-scope="scope">
  <!-- 上传代理弹窗 -->
      <dialogModel
        title="添加多家"
        :visible="VisibleUp"
        @handleClose="handleClose"
        @handleOk="handleConfirm"
      >
        <div class="main-body">
          <div>
            <div class="Content">
              <div class="title-p"><span style="color: red">*</span>上传：</div>
              <div class="Content-box">
                <div class="Upload">
                  <el-upload
                    :drag="true"
                    :limit="limitNum"
                    :auto-upload="false"
                    accept=".xlsx,.xls"
                    :action="UploadUrl1()"
                    :before-upload="beforeUploadFile"
                    :on-change="fileChange"
                    :on-exceed="exceedFile"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :file-list="fileList"
                    :on-remove="listRem"
                    ref="clearFile"
                    :show-file-list="false"
                  >
                    <div class="el-upload__text">
                      <em style="color: #ffffff">点击上传</em>
                    </div>
                  </el-upload>
                  <div class="el-upload__tip" slot="tip">
                    <div class="document-name" style="color: #333333" v-if="fileList[0]">
                      📋{{ fileList[0] ? fileList[0].name : "" }}
                      <div class="icon_document">
                        <i class="el-icon-error firm-clickable" style="color:#c1c1c1" @click="handelError"></i>
                      </div>
                    </div>

                    <span class="firm-clickable" v-if="!fileList[0]" @click="exportToExcel"
                      >&nbsp;&nbsp;模板下载</span
                    >
                  </div>
                </div>
                <span class="span"
                  >（上传格式为xlsx、xls文件,大小不得超过10M，请先下载模板，按照模板内容进行添加信息）</span
                >
              </div>
            </div>
          </div>
        </div>
      </dialogModel>
</template>

<script>
import request from "../../../../../../../../untils/request";
import { downloadTemp } from "../../../../../../../assets/api/Agency/Enterprise";
export default {
  props: {
    VisibleUp: {
      type: Boolean, // 修复：添加props类型校验，避免类型异常
      default: false,
    },
  },
  components: {},
  data() {
    return {
      Upload: 0,
      UploadUrl: "",
      limitNum: 1, // 上传excel时，同时允许上传的最大数
      fileList: [], // excel文件列表（el-upload封装后的对象列表）
      loading: false,
      // type: "", // 修复：添加缺失的type属性，避免模板下载传参undefined
    };
  },
  created() {
    this.UploadUrl = "/global/proxy/importCustomers";
  },
  methods: {
    // 删除上传文件
    handelError(){
      this.fileList = [];
      
    },
    // 取消关闭弹窗
    handleClose() {
      this.fileList = [];
      this.loading = false; // 修复：关闭时重置loading，避免再次打开弹窗无法点击
      this.$emit("handleCloseUp");
    },
    // 确认上传
    handleConfirm() {
      this.handleOk();
    },
    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$message.warning(
        `只能选择 ${this.limitNum} 个文件，当前共选择了 ${
          files.length + fileList.length
        } 个`
      );
    },
    // 修复：文件状态改变时的钩子，受控更新fileList（核心修复点）
    fileChange(file, fileList) {
      const raw = file && (file.raw || file);
      if (raw && raw.name) {
        const extension = raw.name
          .substring(raw.name.lastIndexOf(".") + 1)
          .toLowerCase();
        const size = raw.size / 1024 / 1024;
        if (!["xlsx", "xls"].includes(extension)) {
          this.$message.warning("只能上传后缀是.xlsx、.xls的文件");
          this.$refs.clearFile && this.$refs.clearFile.clearFiles();
          this.fileList = [];
          return;
        }
        if (size > 10) {
          this.$message.warning("文件大小不得超过10M");
          this.$refs.clearFile && this.$refs.clearFile.clearFiles();
          this.fileList = [];
          return;
        }
      }
      // el-upload的fileList是更新后的封装对象列表，直接赋值实现受控
      this.fileList = fileList;
    },
    // 修复：文件移除时，受控更新fileList，而非直接置空
    listRem(file, fileList) {
      this.fileList = fileList;
    },
    // 上传文件之前的钩子, 返回false则停止上传（修复：添加返回值）
    beforeUploadFile(file) {
      const extension = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase(); // 优化：转小写，避免大小写问题
      const size = file.size / 1024 / 1024;
      // 格式校验
      if (!["xlsx", "xls"].includes(extension)) {
        this.$message.warning("只能上传后缀是.xlsx、.xls的文件");
        return false; // 返回false，阻止后续操作
      }
      // 大小校验
      if (size > 10) {
        this.$message.warning("文件大小不得超过10M");
        return false; // 返回false，阻止后续操作
      }
      return true; // 校验通过，返回true
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      this.$message.success("文件上传成功");
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$message.error("文件上传失败，请检查文件或网络");
    },
    // 优化：action设为javascript:void(0)，避免el-upload报空地址警告
    UploadUrl1() {
      return "javascript:void(0)";
    },
    // 核心上传方法（修复：文件获取、loading、异常处理）
    uploadFile() {
      // 1. 校验是否选择文件
      if (this.fileList.length === 0) {
        this.$message.warning(
          "请上传符合模板格式的.xlsx或.xls文件且文件内容不能为空"
        );
        return;
      }
      // 2. 设置loading，防止重复请求（核心修复：提前设置）
      if (this.loading) return;
      this.loading = true;
      // 3. 构建FormData，获取正确的原生文件对象（核心修复：取file.raw）
      const form = new FormData();
      const targetFile = this.fileList[0].raw || this.fileList[0];
      if (!(targetFile instanceof Blob)) {
        this.$message.warning("请重新选择文件上传");
        this.fileList = [];
        this.loading = false;
        return;
      }
      form.append("file", targetFile, targetFile.name || "upload.xlsx");
      // 4. 发起上传请求（勿手动写 multipart/form-data，需由浏览器带 boundary）
      request({
        method: "post",
        url: this.UploadUrl,
        data: form,
      })
        .then((res) => {
          // 5. 响应处理
          if (res.data.code === 0) {
            this.$message.success("操作成功");
            this.fileList = []; // 清空文件列表
            this.$emit("handleConfirmUp"); // 通知父组件刷新/关闭
          } else {
            // 处理接口返回的服务错误
            // this.$message.error(res.data.msg || "导入失败，请检查文件内容");
          }
        })
        .catch((err) => {
          // 6. 异常处理（修复：不直接关闭弹窗，给出错误提示）
          this.$message.error("网络异常或接口错误，请稍后重试");
          // console.error("上传请求异常：", err);
        })
        .finally(() => {
          // 7. 最终：无论成功/失败，都重置loading（核心优化）
          this.loading = false;
        });
    },
    // 触发上传的中间方法
    handleOk() {
      if (this.loading) {
        this.$message.warning("文件上传中，请稍候再确认");
        return;
      }
      this.uploadFile();
    },
    // 模板下载
    exportToExcel() {
      this.loading = true;
      // const data = { type: 0 }; // 修复：移除多余的data嵌套，按接口实际需求传参
      var data = {
        data: {
          type: 0,
        },
      };
      downloadTemp(data)
        .then((res) => {
          // // 1. 处理文件流下载
          // const link = document.createElement("a");
          // const blob = new Blob([res], {
          //   type: "application/vnd.ms-excel;charset=UTF-8",
          // });
          // // 2. 解析文件名（优化：兼容不同的响应头格式）
          // let fileName = "代理企业导入模板.xlsx";
          // const headers = res.headers || sessionStorage.getItem("headersC");
          // if (headers) {
          //   const fileNameMatch = headers.match(/filename\*?=([^;]+)/);
          //   if (fileNameMatch) {
          //     fileName = decodeURIComponent(
          //       fileNameMatch[1].replace(/['"]/g, "")
          //     );
          //   }
          // }
          // // 3. 触发下载
          // link.href = URL.createObjectURL(blob);
          // link.download = fileName;
          // document.body.appendChild(link);
          // link.click();
          // URL.revokeObjectURL(link.href); // 释放URL对象，避免内存泄漏
          // document.body.removeChild(link);
          const link = document.createElement("a"); // 创建a标签
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=UTF-8",
          }); // 设置文件类型
          var encodedStr = sessionStorage.getItem("headersC"); //获取在响应拦截是存入会话存储的文件名
          var index = encodedStr.lastIndexOf("''"); //截取文件名部分
          var aa = encodedStr.substring(index + 2); //截取文件名部分
          const chineseText = decodeURIComponent(aa); // 转中文
          link.href = URL.createObjectURL(blob); // 创建URL
          link.setAttribute("download", chineseText);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.loading = false; // 关闭  加载中
          this.$message.success("模板下载成功");
        })
        .catch((err) => {
          this.$message.error("模板下载失败");
          console.error("模板下载异常：", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="less">
// 原有样式不变，仅优化一个小问题
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
      cursor: pointer; // 优化：添加鼠标指针，提示可点击
    }
  }
  .dialog-title-text {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
.main-body {
  width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  .Content {
    width: 100%;
    min-height: 35px;
    line-height: 35px;
    display: flex;
    font-size: 14px;
    margin-bottom: 15px;
    .title-p {
      width: 140px;
      color: #333333;
      text-align: right;
    }
    .Content-box {
      flex: 1;
      display: flex;
      flex-wrap: wrap;

      .Upload {
        width: 100%;
        display: flex;
        height: 35px;

        /deep/.el-upload-dragger {
          width: 110px !important;
          height: 33px !important;
          line-height: 33px;
          background: #409eff ;
          border: 1px solid #409eff ;
          cursor: pointer;
        }
        .el-upload__tip {
          min-width: 100px;
          height: 35px;
          line-height: 35px;
          font-size: 14px;
          color: #409eff ;
          margin: auto 0 auto 20px;
          cursor: pointer; // 优化：添加鼠标指针
          .document-name {
            padding: 0px 5px;
            border-radius: 5px;
            background-color: rgba(
              150,
              150,
              150,
              0.2
            ); /* 半透明灰色，不突兀 */
            position: relative;
            .icon_document {
              position: absolute;
              top: -15px;
              right: -8px;
              font-size: 20px;
            }
          }
        }
      }
      .span {
        font-size: 12px;
        color: #999999;
        line-height: 18px;
        margin-top: 5px;
        margin-left: -50px; // 修复：移除负边距，避免文字错位
        // width: 100%; // 优化：独占一行，避免换行
      }
    }
  }
}
</style>
